import { GetClient } from '../api-module/control-centre-api-client';
import { RoleEnum } from '@app/api-module/user-management-api-client-v2';
import { RoleMappingService } from '@app/services/role-mapping.service';

export class User {
    id: string;
    username: string;
    email: string;
    firstName: string;
    surname: string;
    title: string;
    countryCode: string;
    number: string;
    extension: string;
    passwordChangeRequired: boolean;

    orgs: Map<string, Org>;

    constructor(init?: Partial<User>) {
        Object.assign(this, init);
    }

    isInOrg = (orgCode: string): boolean => this.orgs?.get(orgCode)?.enabled === true;

    getDefaultSiteId = (orgCode: string): number | null => this.orgs?.get(orgCode)?.defaultSiteId || null;

    getAllowedSites = (orgCode: string, role: RoleEnum): ReadonlyArray<number> | null => {
        const org = this.orgs?.get(orgCode);
        if (!org?.enabled) {
            return null;
        }
        const matchedRoles = org.roles?.filter(orgRole => RoleMappingService.getRoleEnum(orgRole?.name) === role);
        return matchedRoles ? matchedRoles.map(role => role.sites).reduce((accumulator, sites) => [...accumulator, ...sites], []) : null;
    };

    hasRole = (role: RoleEnum, orgCode: string): boolean => {
        const org = this.orgs?.get(orgCode);
        if (!org?.enabled) {
            return false;
        }
        return org.roles ? org.roles.map(role => RoleMappingService.getRoleEnum(role?.name)).includes(role) : false;
    };
}

export class Org extends GetClient {
    defaultSiteId: number | null;
    enabled: boolean | undefined;
    roles: ReadonlyArray<Role> | undefined;

    getAllowedSites(): { allowedSites: number[]; orgWide: boolean } {
        const role = this.roles?.find(this.isSiteSpecificRole);
        const allowedSites = role?.sites ? role.sites : [];
        const orgWide = allowedSites.length === 0;

        return { allowedSites, orgWide };
    }

    private isSiteSpecificRole(role: Role): boolean {
        return [RoleEnum.ClinicalFeedback, RoleEnum.GeneralAccess, RoleEnum.ImagingRequestViewer, RoleEnum.ImagingRequestEditor].includes(
            RoleMappingService.getRoleEnum(role.name)
        );
    }
}

export type Role = {
    name: string;
    id: number;
    sites: number[];
};
